<!-- @format -->

<div class="container sis-pt-md">
  <sis-page-title [title]="pageTitle | translate" [dataCy]="'cart-wizard-title'" />
  <sis-wizard-progress *ngIf="wizardStepKeys?.length > 0" [stepKeys]="wizardStepKeys" [currentStep]="currentStep" />
  <ng-content></ng-content>
</div>
